import { Table } from "antd";
import PropTypes from "prop-types";
import BillingVehicleMobileCard from "./BillingVehicleMobileCard";

const buildColumns = (renderActions) => {
    const columns = [
        { title: "Vehicle Name", dataIndex: "name", key: "name", ellipsis: true },
        { title: "VIN", dataIndex: "vin", key: "vin", ellipsis: true },
        { title: "Plate", dataIndex: "plate", key: "plate", ellipsis: true },
        { title: "Type", dataIndex: "bodyType", key: "bodyType", ellipsis: true },
    ];
    if (renderActions) {
        columns.push({
            title: "Actions",
            key: "actions",
            width: 160,
            fixed: "right",
            render: (_, record) => renderActions(record),
        });
    }
    return columns;
};

const BillingVehicleTable = ({ dataSource, rowSelection, renderActions, size, tableStyles }) => {
    const vehicles = dataSource ?? [];
    const selectedKeys = rowSelection?.selectedRowKeys ?? [];

    const handleMobileCheck = (vehicle, checked) => {
        if (!rowSelection?.onChange) return;
        const key = vehicle.id;
        const nextKeys = checked ? [...selectedKeys, key] : selectedKeys.filter((k) => k !== key);
        const nextRows = vehicles.filter((v) => nextKeys.includes(v.id));
        rowSelection.onChange(nextKeys, nextRows);
    };

    const mobileList =
        !vehicles.length ? null : (
            <div className="flex min-w-0 flex-col gap-3">
                {vehicles.map((vehicle) => {
                    const checkboxProps = rowSelection?.getCheckboxProps?.(vehicle) ?? {};
                    return (
                        <BillingVehicleMobileCard
                            key={vehicle.id}
                            vehicle={vehicle}
                            showCheckbox={Boolean(rowSelection)}
                            checked={selectedKeys.includes(vehicle.id)}
                            checkDisabled={checkboxProps.disabled}
                            onCheckChange={(checked) => handleMobileCheck(vehicle, checked)}
                            actions={renderActions ? renderActions(vehicle) : null}
                        />
                    );
                })}
            </div>
        );

    const desktopTable = (
        <Table
            className="sc-table-frame"
            dataSource={vehicles}
            rowKey="id"
            pagination={false}
            size={size}
            scroll={{ x: 720 }}
            rowSelection={rowSelection}
            styles={tableStyles}
            columns={buildColumns(renderActions)}
        />
    );

    return (
        <>
            <div className="min-w-0 lg:hidden">{mobileList}</div>
            <div className="hidden min-w-0 lg:block">{desktopTable}</div>
        </>
    );
};

BillingVehicleTable.propTypes = {
    dataSource: PropTypes.arrayOf(PropTypes.object),
    rowSelection: PropTypes.object,
    renderActions: PropTypes.func,
    size: PropTypes.string,
    tableStyles: PropTypes.object,
};

export default BillingVehicleTable;
